import React from 'react';
import { ArrowDown, ArrowUp, Check, MoreVertical } from 'lucide-react';
import { esCuadricula, esEleccion, esPregunta, validacionesDe } from '../../../lib/formularios';
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from '../../ui/dropdown-menu';
import { useEditor } from './contexto';
import { validacionInicial } from './EditorValidacion';

function Marca({ activa }) {
  return <span className="fe-menu-marca">{activa && <Check />}</span>;
}

/**
 * Menú "⋮" de una tarjeta: opciones que Google esconde para no llenar la pregunta (descripción,
 * validación, saltos de sección, mezclar…) y mover arriba/abajo, que es la alternativa con teclado a
 * arrastrar.
 */
export default function MenuPregunta({ item, verDescripcion, onVerDescripcion }) {
  const { cambiarItem, moverItemPasos } = useEditor();
  const pregunta = esPregunta(item);
  const set = (campos) => cambiarItem(item.id, campos);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button type="button" className="fe-icono-btn" aria-label="Más opciones" title="Más opciones">
          <MoreVertical />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="fe-menu">
        {pregunta && (
          <>
            <DropdownMenuLabel className="fe-menu-rotulo">Mostrar</DropdownMenuLabel>
            <DropdownMenuItem
              onSelect={() => {
                // Apagar la descripción la borra, como en Google: si no, seguiría viéndose al responder
                if (verDescripcion && item.descripcion) set({ descripcion: '' });
                onVerDescripcion(!verDescripcion);
              }}
            >
              <Marca activa={verDescripcion} /> Descripción
            </DropdownMenuItem>
            {validacionesDe(item.tipo).length > 0 && (
              <DropdownMenuItem onSelect={() => set({ validacion: item.validacion ? null : validacionInicial(item.tipo) })}>
                <Marca activa={!!item.validacion} /> Validación de respuestas
              </DropdownMenuItem>
            )}
            {(item.tipo === 'opcion_multiple' || item.tipo === 'desplegable') && (
              <DropdownMenuItem
                onSelect={() => {
                  const activa = !item.ir_segun_respuesta;
                  set({
                    ir_segun_respuesta: activa,
                    // Al apagarlo, las opciones vuelven a "siguiente" para que no queden saltos ocultos
                    ...(activa ? {} : { opciones: (item.opciones || []).map((o) => ({ ...o, ir_a: 'siguiente' })) }),
                  });
                }}
              >
                <Marca activa={!!item.ir_segun_respuesta} /> Ir a la sección según la respuesta
              </DropdownMenuItem>
            )}
            {esEleccion(item) && (
              <DropdownMenuItem onSelect={() => set({ mezclar_opciones: !item.mezclar_opciones })}>
                <Marca activa={!!item.mezclar_opciones} /> Mezclar el orden de las opciones
              </DropdownMenuItem>
            )}
            {esCuadricula(item) && (
              <>
                <DropdownMenuItem onSelect={() => set({ mezclar_filas: !item.mezclar_filas })}>
                  <Marca activa={!!item.mezclar_filas} /> Mezclar el orden de las filas
                </DropdownMenuItem>
                <DropdownMenuItem onSelect={() => set({ una_por_columna: !item.una_por_columna })}>
                  <Marca activa={!!item.una_por_columna} /> Limitar a una respuesta por columna
                </DropdownMenuItem>
              </>
            )}
            {item.tipo === 'fecha' && (
              <>
                <DropdownMenuItem onSelect={() => set({ fecha: { ...(item.fecha || {}), incluir_anio: item.fecha?.incluir_anio === false } })}>
                  <Marca activa={item.fecha?.incluir_anio !== false} /> Incluir año
                </DropdownMenuItem>
                <DropdownMenuItem onSelect={() => set({ fecha: { ...(item.fecha || {}), incluir_hora: !item.fecha?.incluir_hora } })}>
                  <Marca activa={!!item.fecha?.incluir_hora} /> Incluir hora
                </DropdownMenuItem>
              </>
            )}
            {item.tipo === 'hora' && (
              <DropdownMenuItem onSelect={() => set({ hora: { ...(item.hora || {}), duracion: !item.hora?.duracion } })}>
                <Marca activa={!!item.hora?.duracion} /> Tiempo transcurrido (duración)
              </DropdownMenuItem>
            )}
            <DropdownMenuSeparator />
          </>
        )}
        <DropdownMenuItem onSelect={() => moverItemPasos(item.id, -1)}>
          <ArrowUp /> Mover hacia arriba
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={() => moverItemPasos(item.id, 1)}>
          <ArrowDown /> Mover hacia abajo
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
